export const DEFAULT_ALL_VALUE = '$__all';
export const VAR_QUERY_PARAM_PREFIX = 'var-';
// Escape commas in values to support multi-value variables
function escapeCommas(value) {
    return value.replace(/,/g, '\\,');
}
export function encodeVariableValue(value) {
    if (Array.isArray(value)) {
        return value.join(',');
    }
    return escapeCommas(value ?? '');
}
export const INTERVAL_VARIABLE_AUTO_VALUE = '__auto';
export const DEFAULT_INTERVAL_VARIABLE_OPTIONS = [
    '1m',
    '5m',
    '10m',
    '30m',
    '1h',
    '6h',
    '12h',
    '1d',
    '7d',
    '14d',
    '30d'
];
export const DEFAULT_MIN_INTERVAL_SIZE = '1m';

//# sourceMappingURL=variables.js.map